import { render, staticRenderFns } from "./FIRCaseDetails.vue?vue&type=template&id=5c080f62"
import script from "./FIRCaseDetails.vue?vue&type=script&lang=js"
export * from "./FIRCaseDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports